//search
export const EMAIL_SEARCH_START_LOADING = "EMAIL_SEARCH_START_LOADING";
export const EMAIL_SEARCH_END_LOADING = "EMAIL_SEARCH_END_LOADING";
export const EMAIL_SEARCH_LOADED = "EMAIL_SEARCH_LOADED";
export const SET_EMAIL_FILTER = "SET_EMAIL_FILTER";